/* index.js */

import LoadOverlay from './LoadOverlay'

export {
	LoadOverlay
}
